import {
  LOYALTY_CLAIM_GO_BUTTON_ACTION,
  LOYALTY_CLAIM_GO_BUTTON_SUCCESS,
  LOYALTY_CLAIM_API_ERROR_ACTION,
} from "./actionType";

const INIT_STATE = {
  Loyalty_Claim_Gobtn: [],
  goBtnLoding: false,
};

const LoyaltyClaimReducer = (state = INIT_STATE, action) => {
  switch (action.type) {
    case LOYALTY_CLAIM_GO_BUTTON_ACTION:
      return {
        ...state,
        goBtnLoding: action.config.btnId,
      };

    case LOYALTY_CLAIM_GO_BUTTON_SUCCESS:
      return {
        ...state,
        Loyalty_Claim_Gobtn: action.payload,
        goBtnLoding: false,
      };

    case LOYALTY_CLAIM_API_ERROR_ACTION:
      return {
        ...state,
        goBtnLoding: false,
      };

    default:
      return state;
  }
};

export default LoyaltyClaimReducer;
